import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DrmCapabilityService } from 'src/app/_service/drm-capability.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.css']
})

export class BottomNavComponent implements OnInit {
  navItems = [
    {
      id: 'vids',
      label: 'Vids',
      route: '/cc_prime',
      iconBorder: './assets/navigation-icons/vidsborder.svg',
      iconFill: './assets/navigation-icons/vidsfill.svg',
      isActive: false
    },
    {
      id: 'flix',
      label: 'Flix',
      route: '/prime',
      iconBorder: './assets/navigation-icons/flixborder.svg',
      iconFill: './assets/navigation-icons/flixfill.svg',
      isActive: false
    },
    {
      id: 'search',
      label: 'Search',
      route: '/search',
      iconBorder: './assets/navigation-icons/searchborder.svg',
      iconFill: './assets/navigation-icons/searchfill.svg',
      isActive: false
    },
    {
      id: 'downloads',
      label: 'Downloads',
      route: '/downloads',
      iconBorder: './assets/navigation-icons/downloadborder.svg',
      iconFill: './assets/navigation-icons/downloadfill.svg',
      isActive: false,
      // badgeCount: 3
    },
    {
      id: 'profile',
      label: 'Profile',
      route: '/accounts',
      iconBorder: './assets/navigation-icons/personborder.svg',
      iconFill: './assets/navigation-icons/personfill.svg',
      isActive: false
    }
  ];
  persistentSupport = false;
  isIos = false;

  constructor(
    private router: Router,
    private wl: WhiteLabelService,
    private drmCapability: DrmCapabilityService,
    private bridgeService: IosBridgeService
    ) {}

  async ngOnInit() {
    this.persistentSupport = await this.drmCapability.supportsPersistentLicense();
    this.isIos = await this.bridgeService.isIOS();
    this.setActiveItem();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setActiveItem();
      });
  }

  getLink(path: string): string {
    return this.wl.getPrefixedRoute(path);
  }
  
  onNavItemClick(item: any) {
    this.router.navigate([item.route]);
  }

  onNavItemKeydown(event: any, item: any) {
    if (event.key === 'Enter') {
      this.onNavItemClick(item);
    }
  }

  onIconError(event: any, type: string) {
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }

  private setActiveItem() {
    const currentUrl = this.router.url;
    this.navItems.forEach(item => {
      item.isActive = currentUrl.includes(item.route);
    });
  }

  sendMessage(route:string){
    const win = window as any;
    console.log(route);
    if (win.webkit?.messageHandlers?.iosVideoPlayer) {
      const payload = {
        navigationRoute: route 
      };
      console.log('ios navigation clicked', payload);
      win.webkit.messageHandlers.iosVideoPlayer.postMessage(payload);
    }
  }
}